import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, formValueSelector, change } from "redux-form";
import { SubmissionError } from "redux-form";
import { Link, browserHistory } from "react-router";
import { toastr } from "react-redux-toastr";

import TextField from "../../components/Fields/TextField";
import FieldNormalize from "../../components/Normalize/FieldNormalize";
import FieldValidation from "../../components/Validation/FieldValidation";

import Title from "../../components/Layout/Title";
import api from "../../api/apiUtil";
import { PROFILE_LOAD, PROFILE_UNLOAD, LOGOUT } from "../../actions/Constants";

import _ from "lodash";
import Cookies from "js-cookie";
import uuid from "uuid";
import base64url from "base64url";
import CheckboxField from "../../components/Fields/CheckboxField";
import Modal from "react-bootstrap4-modal";
import Webcam from "react-webcam";

function publicKeyCredentialToJSON(pubKeyCred) {
  const enc = new TextEncoder();
  if (pubKeyCred instanceof ArrayBuffer) {
    return Uint8ArrayToB64String(pubKeyCred);
  } else if (pubKeyCred instanceof Array) {
    return pubKeyCred.map(publicKeyCredentialToJSON);
  } else if (pubKeyCred instanceof Object) {
    const obj = {};
    for (let key in pubKeyCred) {
      obj[key] = publicKeyCredentialToJSON(pubKeyCred[key]);
    }
    return obj;
  } else return pubKeyCred;
}

function b64stringToUint8Array(b64_string) {
  return Uint8Array.from(atob(b64_string), (c) => c.charCodeAt(0));
}

// takes a uint8 array and returns a b64-encoded string representation of it.
// Maybe a function for this wasn't needed since it does one thing (tm) but it
// looks quirky and I feel better having it tested as a unit.
function Uint8ArrayToB64String(array) {
  return btoa(String.fromCharCode.apply(null, new Uint8Array(array)));
}

class Profile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      allowBiometric: false,
      enabledBiometric: false,
      imgSrc: null,
      exibeCaptureFace: false,
      showLgpdModal: false,
      lgpdPassword: "",
      lgpdSubmitting: false,
    };
    this.webcamRef = React.createRef(null);
  }

  componentWillMount() {
    if (this.props.currentUser) {
      this.props.onLoad(Promise.resolve(api.Users.get(this.props.currentUser.id)));
    }
    if (navigator.credentials && window.PublicKeyCredential) {
      window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable().then((a) => {
        console.log(a);
        this.setState({ allowBiometric: a, enabledBiometric: Cookies.get("deviceUUID") ? true : false });
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user) {
      if (nextProps.possui2fa === false || nextProps.possui2fa === true) {
        this.props.dispatch(change("ProfileForm", "possui2fa", nextProps.possui2fa));
      } else {
        this.props.dispatch(change("ProfileForm", "possui2fa", nextProps.user.possui2fa ? 1 : 0));
      }
      if (nextProps.loginBiometrico === false || nextProps.loginBiometrico === true) {
        this.props.dispatch(change("ProfileForm", "loginBiometrico", nextProps.loginBiometrico));
      } else {
        this.props.dispatch(change("ProfileForm", "loginBiometrico", nextProps.user.loginBiometrico ? 1 : 0));
      }
    }
  }

  formSubmit(values) {
    var props = this.props;
    var user = {
      id: this.props.currentUser.id,
      cpf: values.cpf.replace(/[^\d]/g, ""),
      email: values.email,
      nome: values.nome,
    };

    Promise.resolve(api.Users.update(user))
      .then((ret) => {
        toastr.success("Sucesso", "Dados alterados");
      })
      .catch(function (resp) {
        if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  formSubmitSenhas(values) {
    var props = this.props;
    var user = {
      id: this.props.currentUser.id,
      password: values.password,
      passwordOperation: values.passwordOperation,
    };

    Promise.resolve(api.Users.update(user))
      .then((ret) => {
        toastr.success("Sucesso", "Senhas alteradas");
      })
      .catch(function (resp) {
        if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else if (resp.message === "Unprocessable Entity") {
          toastr.error("Erro", "Algum caractere especial inserido na senha não foi aceito.");
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  openLgpdModal() {
    this.setState({ showLgpdModal: true, lgpdPassword: "" });
  }

  closeLgpdModal() {
    this.setState({ showLgpdModal: false, lgpdPassword: "" });
  }

  confirmLgpdDelete() {
    if (!this.state.lgpdPassword) {
      toastr.warning("Atenção", "Informe a senha para confirmar.");
      return;
    }
    const props = this.props;
    this.setState({ lgpdSubmitting: true });
    Promise.resolve(api.Users.selfDeleteLgpd(this.state.lgpdPassword))
      .then(() => {
        toastr.success("Conta excluída", "Sua conta foi removida conforme LGPD.");
        api.Auth.logout();
        props.onLogout();
      })
      .catch((resp) => {
        this.setState({ lgpdSubmitting: false });
        if (resp && (resp.status === 401 || resp.message === "Unauthorized")) {
          toastr.error("Erro", "Senha inválida.");
        } else {
          toastr.error("Erro", "Não foi possível excluir a conta.");
        }
      });
  }

  enableBiometric() {
    var deviceUUID = Cookies.get("deviceUUID");
    if (!deviceUUID) {
      deviceUUID = uuid.v4();
      Cookies.set("deviceUUID", deviceUUID, { expires: 365 });
    }
    const userId = `${this.props.currentUser.id}`;
    Promise.resolve(api.Profile.getChallenge()).then((ret) => {
      navigator.credentials
        .create({
          publicKey: {
            rp: {
              id: document.domain,
              name: "e-Registro",
            },
            user: {
              id: b64stringToUint8Array(base64url(`${this.props.currentUser.id}`)),
              name: this.props.currentUser.user,
              displayName: this.props.currentUser.nome,
            },
            pubKeyCredParams: [
              { type: "public-key", alg: -7 },
              { type: "public-key", alg: -257 },
            ],
            challenge: b64stringToUint8Array(base64url(ret.challenge)),
            excludeCredentials: [],
            authenticatorSelection: {
              requireResidentKey: false,
              authenticatorAttachment: "platform",
              userVerification: "discouraged",
            },
            timeout: 90000,
          },
        })
        .then((attestation) => {
          console.log(attestation);
          const webAuthnAttestation = publicKeyCredentialToJSON(attestation);
          console.log(webAuthnAttestation);
          Promise.resolve(api.Profile.savePublicKey(webAuthnAttestation))
            .then((ret2) => {
              toastr.success("Sucesso", "Biometria cadastrada neste dispositivo");
              console.log(ret2);
              this.setState({ enabledBiometric: true });
            })
            .catch(function (resp) {
              toastr.error("Erro", "Erro ao cadastrar biometria para este dispositivo.");
            });
        });
    });
  }

  disableBiometric() {
    Cookies.remove("deviceUUID", { expires: 365 });
    toastr.success("Sucesso", "Biometria removida neste dispositivo");
    this.setState({ enabledBiometric: false });
  }

  formSubmitLogin(values) {
    var props = this.props;
    var user = {
      id: this.props.currentUser.id,
      possui2fa: values.possui2fa ? true : false,
      loginBiometrico: values.loginBiometrico ? true : false,
      face: values.face,
    };

    Promise.resolve(api.Users.updateTypeLogin(user))
      .then((ret) => {
        this.props.onLoad(Promise.resolve(api.Users.get(this.props.currentUser.id)));
        toastr.success("Sucesso", "Dados alterados");
      })
      .catch(function (resp) {
        if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  capture() {
    const imageSrc = this.webcamRef.current.getScreenshot();
    this.setState({ imgSrc: imageSrc });
  }

  cancelCaptureFace = () => {
    this.setState({ imgSrc: null, exibeCaptureFace: false });
  };

  sendFace() {
    var props = this.props;
    var param = {
      imagem: this.state.imgSrc.split("base64,")[1],
    };
    Promise.resolve(api.Users.sendFace(param))
      .then((ret) => {
        this.props.onLoad(Promise.resolve(api.Users.get(this.props.currentUser.id)));
        this.cancelCaptureFace();
        toastr.success("Sucesso", "Face cadastrada.");
        this.props.reset();
      })
      .catch(function (resp) {
        if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
          api.Auth.logout();
          props.onLogout();
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  }

  render() {
    const { handleSubmit } = this.props;
    const isDetran = _.findIndex(this.props.currentUser.perfis, (perfil) => perfil === "DETRAN") > -1;

    return (
      <div>
        <Title routes={this.props.routes} params={this.props.params} description="Altere as informações do seu perfil" />{" "}
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-heading">Usuário</div>
                <div className="panel-body">
                  <form className="form-horizontal" onSubmit={handleSubmit(this.formSubmit.bind(this))}>
                    <Field name="nome" label="Nome" component={TextField} type="text" description="Seu nome completo" validate={[FieldValidation.required]} required={true} />

                    <Field name="cpf" label="CPF" component={TextField} type="text" description="Seu CPF completo" normalize={FieldNormalize.CPF} required={true} disabled={true} />

                    <Field name="email" label="Email" component={TextField} type="text" validate={[FieldValidation.required, FieldValidation.email]} required={true} />

                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-right">
                          <Link className="btn btn-default" to="/secure">
                            {" "}
                            Cancelar
                          </Link>
                          <button className="btn btn-info"> Salvar</button>
                          <Link className="btn btn-default" onClick={browserHistory.goBack}>
                            <i className="fas fa-arrow-left"></i> Voltar
                          </Link>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-heading">Senhas</div>
                <div className="panel-body">
                  <form className="form-horizontal">
                    <div className="row">
                      <div className="col-md-6">
                        <Field
                          name="password"
                          label="Nova senha de login"
                          component={TextField}
                          type="password"
                          description="Sua senha secreta"
                          validate={[FieldValidation.passwordValid]}
                          required={true}
                        />
                      </div>
                      <div className="col-md-6">
                        <Field
                          name="confirmPassword"
                          label="Confirmação da nova senha de login"
                          component={TextField}
                          type="password"
                          description="Digite novamente sua senha para confirmar"
                          validate={[FieldValidation.passwordValid]}
                          required={true}
                        />
                      </div>
                      <div className="col-md-12">
                        <h5 className="font-bold">Senha específica para acessar a Plataforma E-Registro.</h5>
                      </div>
                    </div>

                    {_.findIndex(this.props.currentUser.perfis, function (perfil) {
                      return perfil === "DETRAN";
                    }) > -1 ? (
                      <div></div>
                    ) : (
                      <>
                        <hr />
                        <div className="row">
                          <div className="col-md-6">
                            <Field
                              name="passwordOperation"
                              label="Nova senha de operação"
                              component={TextField}
                              type="password"
                              description="Sua senha secreta utilizada para confirmar operações"
                              validate={[FieldValidation.passwordValid]}
                              required={true}
                            />
                          </div>
                          <div className="col-md-6">
                            <Field
                              name="confirmPasswordOperation"
                              label="Confirmação de nova senha de operação"
                              component={TextField}
                              type="password"
                              description="Digite novamente sua senha de operação para confirmar"
                              validate={[FieldValidation.passwordValid]}
                              required={true}
                            />
                          </div>
                        </div>
                      </>
                    )}
                    <div>
                      <h5 className="font-bold">Senha específica para comunicações (envio de informações) aos Detrans.</h5>
                    </div>
                    {/* <div>
                      <h5 className="font-bold">Alias prezando pela maior segurança de seus usuários!</h5>
                    </div> */}
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-right">
                          <Link className="btn btn-default" to="/secure">
                            {" "}
                            Cancelar
                          </Link>
                          <button
                            className="btn btn-info"
                            type="button"
                            onClick={this.props.handleSubmit((values) => {
                              return new Promise((resolve, reject) => {
                                const errors = _.assign(validateSenhas(values));
                                if (errors && !_.isEmpty(errors)) {
                                  reject(new SubmissionError(errors));
                                } else {
                                  this.formSubmitSenhas(values);
                                  resolve();
                                }
                              });
                            })}
                          >
                            {" "}
                            Alterar Senhas
                          </button>
                          <Link className="btn btn-default" onClick={browserHistory.goBack}>
                            <i className="fas fa-arrow-left"></i> Voltar
                          </Link>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-heading">Excluir minha conta (LGPD)</div>
                <div className="panel-body">
                  <p>
                    Ao excluir sua conta, seus dados pessoais (nome, CPF, e-mail, telefone, senhas e biometria) serão removidos definitivamente deste sistema. Registros históricos de
                    operações feitas por você serão mantidos de forma anonimizada conforme exigência regulatória.
                  </p>
                  <div className="text-right">
                    <button className="btn btn-danger" type="button" onClick={this.openLgpdModal.bind(this)}>
                      Excluir minha conta
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-heading">Login</div>
                <div className="panel-body">
                  <form className="form-horizontal" onSubmit={handleSubmit(this.formSubmitLogin.bind(this))}>
                    <div className="row">
                      <div className="col-md-4">
                        <Field name="possui2fa" label="Habilitar autenticação 2 fatores" component={CheckboxField} type="text" />
                      </div>
                      <div className="col-md-4">
                        <Field name="loginBiometrico" label="Realizar login via biométria facial" component={CheckboxField} type="text" />
                        {this.props.loginBiometrico ? (
                          <Link className="btn btn-success" onClick={() => this.setState({ exibeCaptureFace: true })}>
                            {" "}
                            {this.props.loginBiometrico === 1 ? "Alterar face" : "Cadastrar face"}
                          </Link>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-right">
                          <Link className="btn btn-default" to="/secure">
                            {" "}
                            Cancelar
                          </Link>
                          <button className="btn btn-info"> Salvar</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-heading">Biometria</div>
                <div className="panel-body">
                  {!this.state.allowBiometric ? (
                    <div>Este dispositivo não suporta autenticação biométrica.</div>
                  ) : (
                    <div className="row">
                      <div className="col-md-12">
                        {this.state.enabledBiometric ? (
                          <button className="btn btn-info" onClick={this.disableBiometric.bind(this)}>
                            Descadastrar biometria
                          </button>
                        ) : (
                          <button className="btn btn-info" onClick={this.enableBiometric.bind(this)}>
                            Cadastrar biometria
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal visible={this.state.showLgpdModal} dialogClassName="modal-max-width">
          <div className="modal-header">
            <h5 className="modal-title">Excluir conta (LGPD)</h5>
          </div>
          <div className="modal-body">
            <p>
              Esta ação é <strong>irreversível</strong>. Seus dados pessoais serão removidos e você será desconectado do sistema.
            </p>
            <p>
              Para confirmar, informe sua <strong>{isDetran ? "senha de login" : "senha de operação"}</strong>:
            </p>
            <input
              type="password"
              className="form-control"
              autoComplete="off"
              value={this.state.lgpdPassword}
              onChange={(e) => this.setState({ lgpdPassword: e.target.value })}
            />
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={this.closeLgpdModal.bind(this)} disabled={this.state.lgpdSubmitting}>
              Cancelar
            </button>
            <button type="button" className="btn btn-danger" onClick={this.confirmLgpdDelete.bind(this)} disabled={this.state.lgpdSubmitting}>
              Confirmar exclusão
            </button>
          </div>
        </Modal>
        <Modal visible={this.state.exibeCaptureFace} dialogClassName="modal-max-width-700">
          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-body">
                  <form className="form-horizontal">
                    <div className="row">
                      <div className="col-md-12">
                        {!this.state.imgSrc && this.state.exibeCaptureFace && <Webcam audio={false} width={650} height={450} ref={this.webcamRef} screenshotFormat="image/jpeg" />}
                        {this.state.imgSrc && (
                          <>
                            <img src={this.state.imgSrc} />
                            <p></p>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-right">
                          <button type="button" className="btn btn-secondary" onClick={this.cancelCaptureFace}>
                            Cancelar
                          </button>
                          {!this.state.imgSrc && (
                            <button type="button" className="btn btn-info" onClick={this.capture.bind(this)}>
                              Capturar foto
                            </button>
                          )}
                          {this.state.imgSrc && (
                            <>
                              &nbsp;
                              <button type="button" className="btn btn-success" onClick={this.sendFace.bind(this)}>
                                Confirmar
                              </button>
                              &nbsp;
                              <button type="button" className="btn btn-warning" onClick={() => this.setState({ imgSrc: null })}>
                                Tirar outra foto
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  if (values.confirmPassword) {
    if (values.password != values.confirmPassword) {
      errors.password = "A senha e a confirmação de senha não conferem";
    }
  }

  if (values.confirmPasswordOperation) {
    if (values.passwordOperation != values.confirmPasswordOperation) {
      errors.passwordOperation = "A senha de operação e a confirmação de senha de operação não conferem";
    }
  }

  return errors;
}

function validateSenhas(values) {
  const errors = {};

  if (!values.password || values.password.length === 0 || !values.password.trim()) {
    errors.password = "Campo obrigatório";
  }
  if (!values.confirmPassword || values.confirmPassword.length === 0 || !values.confirmPassword.trim()) {
    errors.confirmPassword = "Campo obrigatório";
  }
  if (!values.passwordOperation || values.passwordOperation.length === 0 || !values.passwordOperation.trim()) {
    errors.passwordOperation = "Campo obrigatório";
  }
  if (!values.confirmPasswordOperation || values.confirmPasswordOperation.length === 0 || !values.confirmPasswordOperation.trim()) {
    errors.confirmPasswordOperation = "Campo obrigatório";
  }
  if (values.confirmPassword) {
    if (values.password != values.confirmPassword) {
      errors.password = "A senha e a confirmação de senha não conferem";
    }
  }

  if (values.confirmPasswordOperation) {
    if (values.passwordOperation != values.confirmPasswordOperation) {
      errors.passwordOperation = "A senha de operação e a confirmação de senha de operação não conferem";
    }
  }

  return errors;
}

const selector = formValueSelector("ProfileForm");
const mapStateToProps = (state) => ({
  ...state.profile,
  currentUser: state.common.currentUser,
  initialValues: state.profile.user ? { ...state.profile.user, password: "", confirmPassword: "", passwordOperation: "", confirmPasswordOperation: "" } : null,
  loginBiometrico: selector(state, "loginBiometrico"),
  possui2fa: selector(state, "possui2fa"),
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (payload) => dispatch({ type: PROFILE_LOAD, payload }),
  onUnLoad: (payload) => dispatch({ type: PROFILE_UNLOAD }),
  onLogout: () => dispatch({ type: LOGOUT }),
});

const form = reduxForm({
  form: "ProfileForm",
  validate,
});

export default connect(mapStateToProps, mapDispatchToProps)(form(Profile));
